import { Container } from "@components/ui/Container";
import { Section } from "@components/ui/Section";
import { testimonials } from "@data/testimonials";
import styles from "./Testimonials.module.css";

const initials = (name: string) =>
  name
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export function Testimonials() {
  return (
    <Section
      align="center"
      eyebrow="Testimonios"
      title="Lo que dicen nuestros clientes y productores"
    >
      <Container>
        <div className={styles.grid}>
          {testimonials.map((t) => (
            <article key={t.name} className={styles.card}>
              <span className={styles.mark}>“</span>
              <p className={styles.quote}>{t.quote}</p>
              <div className={styles.author}>
                <div className={styles.avatar} aria-hidden>
                  {initials(t.name)}
                </div>
                <div className={styles.authorInfo}>
                  <span className={styles.name}>{t.name}</span>
                  <span className={styles.role}>{t.role}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </Section>
  );
}
